export default __webpack_public_path__ + "static/media/resume.352231ef.png";